<template>
    <div>
        <el-card class="login-box">
            <div slot="header">
                <span>台前人社局 报名系统 · 登录</span>
            </div>
            <el-form ref="form" :model="fields" :rules="rules">
                <el-form-item prop="key">
                    <el-input v-model="fields.key" placeholder="请填写登录帐号" autocomplete="false">
                        <span slot="prepend">
                            <i class="fa fa-fw fa-user"></i>
                        </span>
                    </el-input>
                </el-form-item>
                <el-form-item prop="pwd">
                    <el-input type="password" v-model="fields.pwd" placeholder="请填写登录密码" autocomplete="false" @keyup.enter.native="doSubmit">
                        <span slot="prepend">
                            <i class="fa fa-fw fa-key"></i>
                        </span>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="width:100%;" type="warning" :loading="loading" size="large" @click="doSubmit">
                        <i class="fa fa-fw fa-sign-in"></i>
                        <span style="margin-left: 10px;">登 录</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    import MD5 from 'crypto-js/md5'

    export default {
        name: 'Login',
        data() {
            return {
                loading: false,
                fields: {
                    key: localStorage.getItem('App.LastLoginKey') || '',
                    pwd: ''
                },
                rules: {
                    key: [{
                        required: true,
                        message: '请填写登录帐号',
                        trigger: 'blur'
                    }],
                    pwd: [{
                        required: true,
                        message: '请填写登录密码',
                        trigger: 'blur'
                    }, {
                        type: 'string',
                        min: 3,
                        message: '密码最低3位',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            Submit() {
                console.log('asdasd')
            },
            doSubmit() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        this.$http
                            .post('/comm/user/signin', {
                                key: this.fields.key,
                                pwd: MD5(MD5(this.fields.pwd).toString()).toString()
                            })
                            .then(result => {
                                this.loading = false
                                if (result.code === 0) {
                                    localStorage.setItem('App.LastLoginKey', this.fields.key)
                                    this.$store.commit('signin', result.data)
                                    this.$router.replace('/')
                                }
                            })
                    } else {
                        this.$message.error('请填写完整的信息')
                    }
                })
            }
        }
    }
</script>

<style>
    .login-box {
        width: 400px;
        margin: auto;
        text-align: center;
        margin-top: 20vh;
    }
</style>